module.exports = __webpack_public_path__ + "img/green_highschool.931c5799.svg";